import { createContext } from 'react';
import type {
  SignalRConnectionState,
  SignalREventHandlers,
  SignalREventName,
} from '../../lib/signalr/types';

export interface SignalRContextType {
  connectionState: SignalRConnectionState;
  startConnection: () => Promise<void>;
  stopConnection: () => Promise<void>;
  reconnect: () => Promise<void>;
  on: <T extends SignalREventName>(
    eventName: T,
    handler: SignalREventHandlers[T]
  ) => void;
  off: <T extends SignalREventName>(
    eventName: T,
    handler: SignalREventHandlers[T]
  ) => void;
}

export const SignalRContext = createContext<SignalRContextType | null>(null);
